import { REQ } from "constants/api/requests"
import { IResponse } from "constants/interfaces"

import { BonusType } from "types/api"

import useApi, { parseError } from "util/api"

interface GetBonusesListParams {
  page: number
  pageSize: number
  filters?: { q?: string; type?: BonusType; active?: boolean; tenant?: string }
  sortRow?: string
  sortOrder?: string
}

export const BonusService = {
  async getBonusesList({ page, pageSize, filters, sortRow, sortOrder }: GetBonusesListParams) {
    try {
      const params = {
        page,
        pageSize,
        q: filters?.q,
        type: filters?.type,
        tenant: filters?.tenant,
        active: filters?.active,
        sortRow,
        sortOrder
      }

      const { data } = await useApi.get<IResponse<any>>(REQ.ADMIN_DASHBOARD.BONUSE.LIST, { params })

      if (data?.success) {
        return data?.response
      }
    } catch (error: any) {
      parseError(error)
    }
  },

  async addBonus(payload: any) {
    const { data } = await useApi.post<IResponse<any>>(REQ.ADMIN_DASHBOARD.BONUSE.CREATE, payload)

    if (data?.success) {
      return data?.response
    }
  },

  async editBonus(id: string, payload: any) {
    const { data } = await useApi.put<IResponse<any>>(REQ.ADMIN_DASHBOARD.BONUSE.UPDATE.replace(":id", id), payload)

    if (data?.success) {
      return data?.response
    }
  }
}
